import { useState, useEffect } from "react";
import styles from "./TableContents.module.css";

const TableContents = ({ contents, modalContentContainerRef }) => {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleScroll = () => {
    const container = modalContentContainerRef?.current;
    if (!container) return;

    const containerTop = container.getBoundingClientRect().top;
    let closestId = null;
    let closestDistance = Infinity;

    contents?.forEach((item) => {
      const heading = container.querySelector(`#${item?.id}`);
      if (!heading) return;
      const top = heading.getBoundingClientRect().top - containerTop;
      const distance = Math.abs(top);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestId = item.id;
      }
    });

    if (closestId) {
      setSelectedCategory(closestId);
    }
  };

  useEffect(() => {
    if (!contents) return;
    const initial = contents?.[0]?.id;
    setSelectedCategory(initial);

    modalContentContainerRef?.current?.addEventListener("scroll", handleScroll);

    return () =>
      modalContentContainerRef?.current?.removeEventListener(
        "scroll",
        handleScroll
      );
  }, [modalContentContainerRef, contents]);

  return contents?.length > 0 ? (
    <div className={styles.table_contents}>
      <h4 className={styles.heading}>Table of Contents</h4>
      <ul>
        {contents?.map((item, index) => (
          <li key={index}>
            <a
              onClick={(e) => {
                e.preventDefault();
                const container = modalContentContainerRef?.current;
                const target = container?.querySelector(`#${item?.id}`);
                if (container && target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }}
              href={`#${item?.id}`}
              className={
                item?.id === selectedCategory ? styles.active_class : ""
              }
            >
              {item?.text || item?.linkLabel || item?.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default TableContents;
